e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product' ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery( '.js-e-product-images, #js-e-product-images-modal' ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
            jQuery( event.target ).trigger( 'click' );
        } );
        jQuery( '.js-e-product-images' ).find( '.js-e-jsonpublisher' ).on( 'load.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).addClass( 'is-loading' );
        } ).on( 'loaded.e4.jsonpublisher', function ( event ) {
            // TODO: Test om dette virker på touch devices
            jQuery( event.target ).removeClass( 'is-loading' ).find( '.carousel' ).carousel();
        } );
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                e4.product.addToCart( domForm );
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            if ( arrFormData[ i ].name === 'EcomOrderlineFieldInput_AlcadonParingGUID' ) {
                arrFormData[ i ].value = alcadon.ecom.generateGuid();
            }
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        return e4.cart.addProduct( objFormData );
    }
};
